export default __webpack_public_path__ + "static/media/pwaLogo.c678b2e8.webp";